import { CreateProfileRequest, GetProfilesResponse, ProfileResponse } from '@freighthub/user-profile-core-client'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

import { FeatureFlag, Profile } from '../domain/userProfile'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export const getFeatureFlags = async (
  names?: string[]
): Promise<{
  flags: FeatureFlag[]
}> => {
  return client.post('/api/user-profile/feature-flags/search', {
    names,
  })
}

export const getShipUserPreference = async (): Promise<{
  owner: Profile[]
  customer: Profile[]
}> => {
  return client.get('/api/user-profile/profiles/ship-user-preference')
}

export const setShipUserPreference = async (): Promise<void> => {
  return client.post('/api/user-profile/profiles/ship-user-preference', {
    access: 'owner',
    value: {
      useLegacyUI: true,
    },
  })
}

export const getShipmentBookmarks = async (): Promise<GetProfilesResponse> => {
  return client.get('/api/user-profile/profiles/shipment-bookmark')
}

export const createShipmentBookmark = async (body: CreateProfileRequest): Promise<ProfileResponse> => {
  return client.post('/api/user-profile/profiles/shipment-bookmark', body)
}

export const deleteShipmentBookmark = async (bookmarkId: string): Promise<void> => {
  return client.delete(`/api/user-profile/profiles/shipment-bookmark/${bookmarkId}`)
}

export const getBookingBookmarks = async (): Promise<GetProfilesResponse> => {
  return client.get('/api/user-profile/profiles/booking-bookmark')
}

export const createBookingBookmark = async (body: CreateProfileRequest): Promise<ProfileResponse> => {
  return client.post('/api/user-profile/profiles/booking-bookmark', body)
}

export const deleteBookingBookmark = async (bookmarkId: string): Promise<void> => {
  return client.delete(`/api/user-profile/profiles/booking-bookmark/${bookmarkId}`)
}
